export const initialOnboardingVersion = 2;
export const defaultActivationExploreSampleId = "sample-monologue";
export const defaultInitialOnboardingActivationSampleId = "sample-monologue";
export const cleanupInitialOnboardingActivationSampleId = "sample-cleanup";

const fallbackInitialOnboardingDemoPlaybackId = "Ni6Vo3onPWVa6JJsi9RsV402iXN4ga8mPgSQuDwZUEN00";

const initialOnboardingDemoPlaybackIdByChoice = {
    descript: fallbackInitialOnboardingDemoPlaybackId,
    riverside_zoom: fallbackInitialOnboardingDemoPlaybackId,
    premiere_davinci_fcp: fallbackInitialOnboardingDemoPlaybackId,
    audacity_garageband: fallbackInitialOnboardingDemoPlaybackId,
    new_to_this: fallbackInitialOnboardingDemoPlaybackId,
    other: fallbackInitialOnboardingDemoPlaybackId,
    // Legacy values
    edit_by_transcript: fallbackInitialOnboardingDemoPlaybackId,
    clean_up_recording: fallbackInitialOnboardingDemoPlaybackId,
    edit_interview: fallbackInitialOnboardingDemoPlaybackId,
    start_from_recording: fallbackInitialOnboardingDemoPlaybackId,
    apply_studio_sound: fallbackInitialOnboardingDemoPlaybackId,
    record_something_new: fallbackInitialOnboardingDemoPlaybackId,
    explore_editor: fallbackInitialOnboardingDemoPlaybackId,
};

const initialOnboardingRoleLabelByValue = {
    creator_self_employed: "Creator / Self-employed",
    customer_success_support: "Customer Success & Support",
    design_research: "Design & Research",
    engineering_product: "Engineering & Product",
    hr_people_recruiting_ld: "HR (People, Recruiting, L&D)",
    marketing: "Marketing",
    sales: "Sales",
    other: "Other",
};

const initialOnboardingFirstThingLabelByValue = {
    descript: "Descript",
    riverside_zoom: "Riverside or Zoom",
    premiere_davinci_fcp: "Premiere, DaVinci, or Final Cut",
    audacity_garageband: "Audacity or GarageBand",
    new_to_this: "I'm new to recording and editing",
    other: "Other",
    // Legacy values
    edit_by_transcript: "Edit by transcript",
    clean_up_recording: "Clean up a recording",
    edit_interview: "Edit an interview",
    start_from_recording: "Apply Studio Sound",
    apply_studio_sound: "Apply Studio Sound",
    record_something_new: "Record something new",
    explore_editor: "Explore the editor",
};

export const getInitialOnboardingDemoPlaybackId = (choice) =>
    initialOnboardingDemoPlaybackIdByChoice[String(choice || "").trim()] || fallbackInitialOnboardingDemoPlaybackId;

export const getInitialOnboardingRoleLabel = (value) =>
    initialOnboardingRoleLabelByValue[String(value || "").trim()] || "Unknown role";

export const getInitialOnboardingFirstThingLabel = (value) =>
    initialOnboardingFirstThingLabelByValue[String(value || "").trim()] || "Unknown choice";

export const getInitialOnboardingDesktopActivationAction = (choice) => {
    // No longer routing to activation demos — users land on the dashboard.
    return null;
};
